import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminSettingShoppingCart';
import withAuth from '../../../common/WithAuth';
import SettingShoppingCartPage from '../../../pages/Admin/SettingShoppingCart/SettingShoppingCartPage';

const mapStateToProps = (state) => {
    const isLoading = state.adminSettingShoppingCart.get.isFetching
    || state.adminSettingShoppingCart.update.isFetching;

    return {
        eventInfo: state.eventManagement.infoEvent.data,
        settingShoppingCartData: state.adminSettingShoppingCart.get.data,
        errors: state.adminSettingShoppingCart.update.errors,
        isCompleted: state.adminSettingShoppingCart.update.isCompleted,
        isCompletedGet: state.adminSettingShoppingCart.get.isCompleted,
        isSuccessful: state.adminSettingShoppingCart.update.isSuccessful,
        isLoading,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getSettingShoppingCart: (eventShortName) => {
        dispatch(Action.getSettingShoppingCartRequested(eventShortName));
    },
    updateSettingShoppingCart: (param) => {
        dispatch(Action.updateSettingShoppingCartRequested(param));
    },
    getSettingShoppingCartClear: () => {
        dispatch(Action.getSettingShoppingCartClear());
    },
    updateSettingShoppingCartClear: () => {
        dispatch(Action.updateSettingShoppingCartClear());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingShoppingCartPage);
